import { render, staticRenderFns } from "./LoginPage.component.pug?vue&type=template&id=3652b5c6&scoped=true&lang=pug&"
import script from "./LoginPage.component.ts?vue&type=script&lang=ts&"
export * from "./LoginPage.component.ts?vue&type=script&lang=ts&"
import style0 from "./LoginPage.component.scss?vue&type=style&index=0&id=3652b5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652b5c6",
  null
  
)

export default component.exports